import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        p: 2,
        textAlign: "center",
        bgcolor: "background.paper",
        borderTop: "1px solid #e0e0e0",
        display: { xs: "none", sm: "block" }, 
      }}
    >
      <Typography variant="body2" color="textSecondary">
        {t("footer.copyright", { year: new Date().getFullYear() })}
      </Typography>
    </Box>
  );
};

export default Footer;
